import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Table } from 'react-bootstrap';
import dayjs from 'dayjs';
import { formatCost } from './costHelpers';

const COLUMNS = [
  { key: 'ipfDate', label: 'Date', render: item => (item.ipfDate ? dayjs(item.ipfDate).format('DD/MM/YYYY HH:mm') : '—') },
  { key: 'ipfId', label: 'Ipf Id' },
  { key: 'ipfItemId', label: 'Ipf ItemId' },
  { key: 'ipfJobNo', label: 'Job No' },
  { key: 'winNo', label: 'Win No' },
  { key: 'pCode', label: 'Fault Code' },
  { key: 'itemCostPrice', label: 'Cost', render: item => formatCost(item.itemCostPrice) }
];

export default function IpfItemsDetailModal({ show, onHide, title, items }) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {items.length === 0 ? (
          <div className="text-center text-muted py-3">No items.</div>
        ) : (
          <>
            <div className="text-muted" style={{ fontSize: 12, marginBottom: 8 }}>
              Total: <strong>{items.length}</strong> item{items.length === 1 ? '' : 's'}
            </div>
            <Table responsive size="sm" bordered>
              <thead>
                <tr>
                  <th style={{ width: 44 }}>#</th>
                  {COLUMNS.map(col => (
                    <th key={col.key}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={item.ipfId || `${item.ipfJobNo}-${item.winNo}-${idx}`}>
                    <td>{idx + 1}</td>
                    {COLUMNS.map(col => (
                      <td key={col.key}>{col.render ? col.render(item) : item[col.key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

IpfItemsDetailModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};
